/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { SmsEnrollmentResponseFragment } from './smsEnrollmentFragment';
import { gql } from '@apollo/client';
import { SmsEnrollmentResponseFragmentDoc } from './smsEnrollmentFragment';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type RemoveSmsEnrollmentMutationVariables = Types.Exact<{
  mobilePhoneId: Types.Scalars['ID'];
}>;


export type RemoveSmsEnrollmentMutation = (
  { __typename?: 'Mutation' }
  & { removeSmsEnrollment: Types.Maybe<(
    { __typename?: 'SmsEnrollmentResult' }
    & SmsEnrollmentResponseFragment
  )> }
);


export const RemoveSmsEnrollmentDocument = gql`
    mutation removeSmsEnrollment($mobilePhoneId: ID!) {
  removeSmsEnrollment(mobilePhoneId: $mobilePhoneId) {
    ...SmsEnrollmentResponse
  }
}
    ${SmsEnrollmentResponseFragmentDoc}`;
export type RemoveSmsEnrollmentMutationFn = Apollo.MutationFunction<RemoveSmsEnrollmentMutation, RemoveSmsEnrollmentMutationVariables>;

/**
 * __useRemoveSmsEnrollmentMutation__
 *
 * To run a mutation, you first call `useRemoveSmsEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSmsEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSmsEnrollmentMutation, { data, loading, error }] = useRemoveSmsEnrollmentMutation({
 *   variables: {
 *      mobilePhoneId: // value for 'mobilePhoneId'
 *   },
 * });
 */
export function useRemoveSmsEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSmsEnrollmentMutation, RemoveSmsEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSmsEnrollmentMutation, RemoveSmsEnrollmentMutationVariables>(RemoveSmsEnrollmentDocument, options);
      }
export type RemoveSmsEnrollmentMutationHookResult = ReturnType<typeof useRemoveSmsEnrollmentMutation>;
export type RemoveSmsEnrollmentMutationResult = Apollo.MutationResult<RemoveSmsEnrollmentMutation>;
export type RemoveSmsEnrollmentMutationOptions = Apollo.BaseMutationOptions<RemoveSmsEnrollmentMutation, RemoveSmsEnrollmentMutationVariables>;